// extracted by mini-css-extract-plugin
export default {"imageWrapper":"fK-z","twoColumnImage":"gK-z"};